import { useMutation } from '@tanstack/react-query'
import { instance } from '../instance'

export const useUploadToAWS = () => {
  async function updateDN(payload: { file: any }) {
    const { data } = await instance.post(
      `https://backend.qwizfun.com/admin/image/aws-upload`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return data
  }
  const uploadToAWS = useMutation({
    mutationFn: updateDN,
    mutationKey: ['upload to aws'],
  })
  return uploadToAWS
}
